import styles from "./WorkoutPlanDialog.module.scss";
import { SkeletonItem } from "../skeletons/SkeletonItem";

export const WorkoutPlanDialogSkeleton = () => {
  return (
    <div className={styles.skeleton}>
      {[0, 1].map((idx) => (
        <div className={styles.skeleton_card} key={idx}>
          <div className={styles.skeleton_card_head}>
            <SkeletonItem isLoading value="" width="36px" />
            <SkeletonItem isLoading value="" width="150px" />
          </div>
          <div className={styles.skeleton_card_sets}>
            {[0, 1, 2].map((j) => (
              <div className={styles.skeleton_card_set_row} key={j}>
                <SkeletonItem isLoading value="" width="100%" />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
